import { render, staticRenderFns } from "./CRMCreateResponse.vue?vue&type=template&id=b8fe3bde&scoped=true"
import script from "./CRMCreateResponse.vue?vue&type=script&lang=js"
export * from "./CRMCreateResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fe3bde",
  null
  
)

export default component.exports